/* sugar:assets/card-swatches.js@2.1.8 */
/*
 * Product card swatches — tapping a swatch on a card shows that color's image and points
 * the card's links at that variant. The card's label and color line follow the swatch.
 * A sibling-product swatch (each color its own product) swaps the card to that product:
 * photos, title, color, price, links and quick add. Delegated from the document so cards
 * that arrive through the filter refetch or the theme editor need no wiring.
 */
(function () {
  'use strict';

  if (window.SugarCardSwatches) return;

  function setImage(image, src, srcset) {
    if (!image || !src) return;
    image.removeAttribute('srcset');
    image.src = src;
    if (srcset) image.srcset = srcset;
  }

  function setText(el, text) {
    if (!el) return;
    el.textContent = text || '';
    var tags = el.closest('.sugar-card__tags');
    if (tags) tags.hidden = !text;
  }

  /* A swipe row that was moved on comes back to the first photo, which is the one that changed. */
  function rewind(card) {
    var track = card.querySelector('.sugar-card__track');
    if (track && track.scrollLeft) track.scrollLeft = 0;
  }

  function siblingSwap(card, swatch) {
    var url = swatch.getAttribute('data-url');
    var image = card.querySelector('.sugar-card__image:not(.sugar-card__image--secondary):not(.sugar-card__image--extra)');
    setImage(image, swatch.getAttribute('data-image'), swatch.getAttribute('data-srcset'));
    var second = card.querySelector('.sugar-card__image--secondary');
    var src2 = swatch.getAttribute('data-image2');
    if (second) {
      if (src2) {
        second.hidden = false;
        setImage(second, src2, '');
      } else {
        second.hidden = true;
      }
      // A sibling with one photo zooms on hover like any card without a second photo.
      var media = second.closest('.sugar-card__media');
      if (media && !second.classList.contains('sugar-card__image--phone')) media.classList.toggle('sugar-card__media--second', !!src2);
    }
    // The other product's further photos aren't on the card: the row shrinks to what is.
    Array.prototype.forEach.call(card.querySelectorAll('.sugar-card__image--extra'), function (img) { img.hidden = true; });
    var dots = card.querySelectorAll('.sugar-card__dot');
    Array.prototype.forEach.call(dots, function (dot, i) { dot.hidden = i > (src2 ? 1 : 0); });
    if (dots.length) {
      var row = dots[0].parentElement;
      row.hidden = !src2;
    }

    Array.prototype.forEach.call(card.querySelectorAll('.sugar-card__media-link, .sugar-card__title a'), function (a) { a.href = url; });
    var title = card.querySelector('.sugar-card__title a');
    if (title) title.textContent = swatch.getAttribute('data-title') || title.textContent;
    var link = card.querySelector('.sugar-card__media-link');
    if (link) link.setAttribute('aria-label', swatch.getAttribute('data-title') || '');

    var price = card.querySelector('.sugar-featured-collection__card-price-current');
    if (price) price.textContent = swatch.getAttribute('data-price') || price.textContent;
    var compareText = swatch.getAttribute('data-compare') || '';
    var compare = card.querySelector('.sugar-featured-collection__card-price-compare');
    if (compare) {
      compare.textContent = compareText;
      compare.hidden = !compareText;
    } else if (compareText && price) {
      compare = document.createElement('span');
      compare.className = 'sugar-featured-collection__card-price-compare';
      compare.textContent = compareText;
      var order = price.parentElement;
      if (order && order.classList.contains('sugar-featured-collection__card-price--compare-first')) price.before(compare);
      else price.after(compare);
    }
    var priceRow = price && price.parentElement;
    if (priceRow) priceRow.classList.toggle('sugar-featured-collection__card-price--on-sale', !!compareText);

    Array.prototype.forEach.call(card.querySelectorAll('[data-quick-add]'), function (button) {
      button.setAttribute('data-quick-add', url.split('?')[0]);
    });
    var variant = swatch.getAttribute('data-variant');
    Array.prototype.forEach.call(card.querySelectorAll('product-form input[name="id"]'), function (input) {
      if (variant) input.value = variant;
    });
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-card-swatch], [data-card-sibling]');
    if (!swatch) return;
    var card = swatch.closest('.sugar-card');
    if (!card) return;

    event.preventDefault();

    Array.prototype.forEach.call(card.querySelectorAll('[data-card-swatch], [data-card-sibling]'), function (s) {
      var on = s === swatch;
      s.classList.toggle('is-active', on);
      s.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    if (swatch.hasAttribute('data-label')) setText(card.querySelector('[data-card-label]'), swatch.getAttribute('data-label'));
    var color = card.querySelector('[data-card-subtitle]');
    if (color && swatch.hasAttribute('data-color')) color.textContent = swatch.getAttribute('data-color');
    rewind(card);

    if (swatch.hasAttribute('data-card-sibling')) {
      siblingSwap(card, swatch);
      return;
    }

    var image = card.querySelector('.sugar-card__image:not(.sugar-card__image--secondary)');
    var src = swatch.getAttribute('data-image');
    if (image && src) {
      setImage(image, src, swatch.getAttribute('data-srcset'));
      card._swOriginalSrc = src;
      card._swOriginalSrcset = swatch.getAttribute('data-srcset') || '';
    }

    var url = swatch.getAttribute('data-url');
    if (url) {
      Array.prototype.forEach.call(card.querySelectorAll('.sugar-card__media-link, .sugar-card__title a'), function (a) {
        a.href = url;
      });
    }
  });

  // Desktop: hovering a swatch previews its image; leaving the row restores the chosen one.
  var HOVER = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : { matches: false };

  function show(card, swatch) {
    var image = card.querySelector('.sugar-card__image:not(.sugar-card__image--secondary)');
    if (!image) return;
    var src = swatch && swatch.getAttribute('data-image');
    if (!src) {
      src = card._swOriginalSrc;
      if (!src) return;
      image.srcset = card._swOriginalSrcset || '';
      image.src = src;
      return;
    }
    image.removeAttribute('srcset');
    image.src = src;
    var srcset = swatch.getAttribute('data-srcset');
    if (srcset) image.srcset = srcset;
  }

  document.addEventListener('mouseover', function (event) {
    if (!HOVER.matches) return;
    var swatch = event.target.closest('[data-card-swatch]');
    if (!swatch) return;
    var card = swatch.closest('.sugar-card');
    if (!card) return;
    if (!card._swOriginalSrc) {
      var image = card.querySelector('.sugar-card__image:not(.sugar-card__image--secondary)');
      if (image) {
        card._swOriginalSrc = image.src;
        card._swOriginalSrcset = image.srcset;
      }
    }
    show(card, swatch);
  });

  document.addEventListener('mouseout', function (event) {
    if (!HOVER.matches) return;
    var row = event.target.closest('[data-card-swatches]');
    if (!row || (event.relatedTarget && row.contains(event.relatedTarget))) return;
    if (!row.querySelector('[data-card-swatch]')) return;
    var card = row.closest('.sugar-card');
    if (!card) return;
    show(card, row.querySelector('[data-card-swatch].is-active'));
  });

  window.SugarCardSwatches = true;
})();
